/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';
import { ItemsService, SalesService } from 'shared/services';
import { Spinner, Form, Button } from 'react-bootstrap';
// import { BiddingAndWatching } from 'shared/bidding-and-watching/BiddingAndWatching';
import { convertToMaintainData, getMaintainData, watching } from 'shared/settings/stateMaintain';


import './Watching.scss';
import store from 'features/store';
import { logout } from 'shared/settings/auth';
import { AddAriaLabel } from 'shared/utils/AddAriaLabel';

/**


@Author Karthik 

@param

@return html page for Watching

**/

class Watching extends Component {

    constructor(props) {
        super(props);
        this.maintainKey = `${watching}${this.props.history.location.pathname}`;

        this.saleCardView = createRef();
        this.scrollRef = createRef();

        this.state = {
            moreButtonCheck: false,
            noData: true,
            deleteItemsList: {},
            noRecordsFound: false,
            pageLoading: true,
            nextList: null,
            watchingList: [],
            displayData: { patchData: null },
            loaderForMore: false,
            selectedAll: false,
            includeClosedItems: false,
            selectedItems: [],
            confirmLoader: false,
            subloader: false,
            filterLoading: false,
            sortBasedOn: "closing-soon",
            watchingData: {
                "sort": [{ "field": "itemclosetime", "direction": "asc" }],
                // field: ["id", "itemid", "bidwonstatus", "buyerid", "currentbid", "islistingclosed", "itemclosetime"]
            },
            applyFilter: false,
            sortBy: null,
            scrollTo: 0,
            sortByValue: null,
            isVisible: false,
            pageClientWidth: 16,
            onLoad: false,
            includeSneakPeekItems: false
        }
    }

    componentDidMount() {
        this.getPreviousValues();
        document.addEventListener('resize', this.resize)
    }

    componentDidUpdate(prevProp) {
        if (this.props.getNextItem && !prevProp.getNextItem && !this.state.loaderForMore) {
            this.getMoreList();
        }

        if (!this.state.pageLoading && !this.state.onLoad) {
            this.setState({onLoad: true});
        }

        if (JSON.stringify(prevProp.user) !== JSON.stringify(this.props.user)) {
            this.getPreviousValues();
        }
    }

    getPreviousValues = () => {
        try {
            const previous = getMaintainData(this.maintainKey);
            // let itemLists = previous.watchingList
            // const watchingItemId = itemIds.map((elem) => elem.id)
            // previous = this.extraDetailsUpdate(itemLists, true)
            const check = this.props.history.action === "POP" && this.props.previousPath.component === "itemview";
            if (check && previous && Object.keys(previous).length) {
                this.setState({
                    ...this.state,
                    ...previous,    
                }, () => {
                    store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Watching" } });
                });
            } else {
                this.getRequiredData(false, true);
                store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Watching" } });
            }
        } catch (error) {
            store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Watching" } });
            this.getRequiredData(false, true);
        }
    }

    getRequiredData = async (append = false, applyFilter = false) => {
        const _utctime = await SalesService.UTCForSale();
        const commonUTC = _utctime.status === 200 ? _utctime.data.data[0].utctime : moment.utc().format('YYYY-MM-DD HH:mm:ss');
        const watchingData = this.state.watchingData;
        const filterData = {};
        filterData["filter"] = [{ "field": "sneekpeak", "value": 1, op: "=", join: "AND" }]
        watchingData["page"] = this.state.nextList && append ? { "size": 48, next: this.state.nextList } : { 'size': 48 };
        if (!this.state.includeClosedItems && !this.state.includeSneakPeekItems) {
            filterData["filter"] = [
                { "field": "sneekpeak", "value": 1, "op": "=", "join": "AND" },
                { "field": "itemclosetime", "value": null, "op": "IS", "join": "OR" },
                { "field": "itemclosetime", "value": commonUTC, "op": ">", "join": "AND" }
            ]
        }
        if (this.state.includeSneakPeekItems) {
            filterData["filter"] = [{ "field": "sneekpeak", "value": 1, op: "=", join: "AND" }]
        }
        ItemsService.getWatchList({ ...watchingData, ...filterData }).then(
            watchResponse => {
                const tempList = watchResponse.data.data;
                const tempItemsList = append ? this.state.watchingList.concat(tempList) : tempList;
                const pageNext = watchResponse.data.page && watchResponse.data.page.keyset && watchResponse.data.page.keyset.next ? watchResponse.data.page.keyset.next : null;
                const filter = tempList.map(x => x.itemid);
                this.setState({
                    nextList: pageNext,
                    watchingList: tempItemsList,
                    applyFilter: applyFilter,
                    sortBy: { sortingArray: JSON.parse(JSON.stringify(tempList)), key: "itemid" }
                }, () => {
                    let newDate = moment().subtract(7, 'days').format("YYYY-MM-DD 00:00:00");
                    let endDate = moment().add(7, 'days').format("YYYY-MM-DD 23:59:59");
                    if (tempList.length > 0) {
                        const itemsData = {
                            "filter": [
                                { "field": "id", "value": [filter], "op": "IN", "join": "AND" },
                            ]
                        };    
                        // Removed itemstatus pending filter and added days for +7 and -7 days for auction sneek peak                         
                        // if (!this.state.includeSneakPeekItems) {
                        //     itemsData.filter.push(
                        //         { "field": "itemstatus", "value": "Pending", "op": "!=", "join": "AND" }
                        //     )
                        // } 
                        if(this.state.includeSneakPeekItems) {
                            itemsData.filter.push(
                                { "field": "starttime", "value": newDate, "op": ">=", "join": "AND" },
                                { "field": "starttime", "value": endDate, "op": "<=", "join": "AND" }
                            )
                        }
                        if (append) {
                            this.saleCardView.current.getItemsList(true, { data: itemsData });
                        } else {
                            this.setState({
                                ...this.state,
                                displayData: {
                                    ...this.state.displayData,
                                    patchData: itemsData
                                },
                                pageLoading: false,
                                confirmLoader: false,
                                subloader: false,
                                noRecordsFound: false,
                                noData: false,
                            });
                        }
                    } else {
                        this.setState({
                            noRecordsFound: true,
                            pageLoading: false,
                            confirmLoader: false,
                            subloader: false,
                            noData: true,
                            loaderForMore: false,
                            filterLoading: false,
                        });
                    }
                });
            }
        ).catch(error => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(this.props.history, false);
                this.setState({
                    noRecordsFound: true,
                    pageLoading: false,
                    confirmLoader: false,
                    subloader: false,
                    noData: false,
                    filterLoading: false
                })
            } else {
                this.setState({
                    noRecordsFound: true,
                    pageLoading: false,
                    confirmLoader: false,
                    subloader: false,
                    loaderForMore: false,
                    nextList: null,
                });
            }
        });
    }

    getMoreList = () => {
        this.setState({
            loaderForMore: true,
            CheckSelectAll: true
        }, () => {
            this.getRequiredData(true);
        });
    }

    getItemsList = (event) => {
        if (this.state.CheckSelectAll && this.state.selectedAll) {
            this.setState({
                selectedAll: true
            }, () => {
                this.saleCardView.current.toggleSelectAll(this.state.selectedAll);
            });
        }
        this.setState({
            noData: event.length === 0,
            loaderForMore: false,
            filterLoading: false,
        }, () => {
            this.handlePreviousData(event.scrollPage);
        });
    }

    deleteItemsList = (event) => {
        this.setState({
            deleteItemsList: event
        });
    }

    selectedItems = (event) => {
        this.setState({
            selectedAll: event.selectedAll,
            selectedItems: event.selectedItems
        });
    }

    toggleSelectAll = () => {
        this.setState({
            selectedAll: !this.state.selectedAll
        }, () => {
            this.saleCardView.current.toggleSelectAll(this.state.selectedAll);
        });
    }

    toggleClosedItems = () => {
        this.setState({
            subloader: true,
            filterLoading: true,
            includeClosedItems: !this.state.includeClosedItems
        }, () => {
            if (!this.state.includeClosedItems && ['won', 'not-won'].includes(this.state.sortBasedOn)) {
                return this.filterChange(null, 'closing-soon');
            }
            this.getRequiredData(false, true)
        })
    };


    onChangeSelectAll = (event) => {
        this.setState({
            selectedAll: !this.state.selectedAll
        }, () => {
            this.saleCardView.current.toggleSelectAll(this.state.selectedAll);
        });
    }

    removeFromWatch = () => {
        this.setState({
            confirmLoader: true,
            subloader: true,
            pageLoading: true,
        }, () => {
            const removeData = {
                "data": {
                    "itemIds": this.state.selectedItems
                }
            };
            ItemsService.removeFromWatch(removeData).then(
                response => {
                    this.setState({
                        selectedAll: this.state.selectedAll ? !this.state.selectedAll : this.state.selectedAll,
                        subloader: true,
                        watchingList: [],
                        filterLoading: true,
                        pageLoading: false,
                        selectedItems: []
                    }, () => {
                        this.getRequiredData(false, true);
                    });
                }
            ).catch(error => {
                this.setState({
                    confirmLoader: false,
                    subloader: false,
                    pageLoading: false,
                    selectedItems: []
                });
            });
        });

    }

    filterChange = (event, defaultValue) => {
        const value = defaultValue || event.target.value;
        const fields = {
            "closing-soon": { field: "itemclosetime", value: moment.utc().format('YYYY-MM-DD HH:mm:ss'), op: ">", direction: "asc" },
            "lowest-price": { field: "currentbid", value: "Won", op: "=", direction: "asc" },
            "highest-price": { field: "currentbid", value: "Won", op: "=", direction: "desc" },
            "won": { field: "biddingstatus", value: "Won", op: "=", direction: "desc" },
            "not-won": { field: "biddingstatus", value: "Won", op: "!=", direction: "asc" },
            "listing-open": { field: "openitem", value: "Won", op: "=", direction: "desc" },
            "listing-closed": { field: "closeditem", value: "Won", op: "=", direction: "desc" },
        };
        const final = fields[value];
        this.setState({
            subloader: true,
            watchingList: [],
            nextList: null,
            filterLoading: true,
            sortBasedOn: value,
            watchingData: {
                "sort": [{ "field": final.field, "direction": final.direction }],
            },
            sortByValue: value,
        }, () => {
            this.getRequiredData(false, true);
        });
    }

    handlePreviousData = (applyScroll) => {
        if (applyScroll) {
            this.scrollToPrevious();
        }
    }

    scrollToPrevious = () => {
        this.scrollRef.current.scrollTo({ top: this.state.scrollTo || 0, left: 0 });
    }

    handleScroll = (event) => {
        try {
            const scrollTop = event?.target?.scrollTop;
            if (scrollTop) {
                this.setState({
                    scrollTo: scrollTop,
                    pageClientWidth: this.scrollRef?.current?.clientWidth,
                    isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                });
            } else {
                this.setState({
                    pageClientWidth: this.scrollRef?.current?.clientWidth,
                    isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                })
            }
        } catch (error) {

        }
    };

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    resize = () => {
        this.setState({
            pageClientWidth: this.scrollRef?.current?.clientWidth,
        });
    }

    stateMaintenance = () => {
        const data = {
            ...this.state
        };
        convertToMaintainData(this.maintainKey, data);
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    extraDetailsUpdate = (event, flag) => {
        const itemsList = event;
        const itemId = [];
        if(flag){
            itemsList.forEach(item => {
                itemId.push(Number(item.itemid));
            });
        } else {
            itemsList.forEach(item => {
                itemId.push(Number(item));
            });
        }
        const watchingData = this.state.watchingData;
        watchingData["page"] =  { 'size': itemId.length };
        watchingData["filter"] = [{ "field": "itemid", "value": [itemId], "op": "IN", "join": "AND" }]
        ItemsService.getWatchList(watchingData).then(
            response => {
                const watchList = JSON.parse(JSON.stringify(this.state.watchingList));
                const tempList = response.data.data;
                tempList.forEach(y => {
                    const index = watchList.findIndex(z => z.itemid === y.itemid);
                    if (index !== -1) {
                        watchList[index] = y;
                    } else {
                        watchList.push(y);
                    }
                });
                this.setState({
                    watchingList: watchList
                })
            }
        ).catch(
            error => {

            }
        );
    }

    toggleSneakPeekItems = () => {
        this.setState({
            subloader: true,
            filterLoading: true,
            includeSneakPeekItems: !this.state.includeSneakPeekItems
        }, () => {
            this.getRequiredData(false, true)
        })
    };

    render() {
        return (
            <div className="watching-page" ref={this.scrollRef} onScroll={this.handleScroll} style={{ ...this.props.style }}>
                <AddAriaLabel loading={this.state.onLoad} config={[
                    {id: 'sneakpeekSelect', label: 'Include Sneak Peek Items'},
                    {id: 'closedItemsSelect', label: 'Include Closed Items'},
                    {id: 'customControlSelect', label: 'Select All'}
                ]} />
                {
                    this.state.isVisible && !this.state.noData && !this.state.filterLoading ?
                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                            <i className="fas fa-arrow-up"></i>
                        </div> : null
                }
                <div className={`datatable ${this.state.noData || this.state.filterLoading ? 'h-100' : ''}`}>
                    {
                        this.state.pageLoading ?
                            <div className={`d-flex justify-content-center h-100 ${this.state.noData || this.state.filterLoading ? 'align-items-center' : ''} mt-3`}>
                                <div className="large-screen-width">
                                    <div className="loader d-flex align-items-center justify-content-center h-100">
                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                    </div>
                                </div>
                            </div> :
                            <div className={`d-flex justify-content-center h-100 ${this.state.noData && !this.state.applyFilter ? 'align-items-center' : ''} mt-3`}>
                                <div className="large-screen-width">
                                    {
                                        this.state.noData && !this.state.applyFilter ? null :
                                            <div className="d-md-flex align-items-center justify-content-between mb-3 px-15">
                                                <div className="d-flex align-items-center  top-left">
                                                    <div className="text-bold">Sort by:</div>
                                                    <Form.Group className="remove-bottom" controlId="formGridState">
                                                        <Form.Control as="select" className="sort" aria-label='sort by' value={this.state.sortByValue} onChange={this.filterChange}>
                                                            <option value="closing-soon">Closing Soon</option>
                                                            <option value="lowest-price">Lowest Price</option>
                                                            <option value="highest-price">Highest Price</option>
                                                            {/* <option value="listing-open">Open</option> */}
                                                            {/* <option value="listing-closed">Closed</option> */}
                                                            {this.state.includeClosedItems && <> <option value="won">Won</option>
                                                                <option value="not-won">Not Won</option></>}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                                <div className="d-flex align-items-center top-right">
                                                    {/* { this.props.user.membershipCompleted ? <div className={`d-flex align-items-center select-all-div ${this.state.includeSneakPeekItems ? 'selected' : 'disabled'}`} >
                                                        <Form.Check
                                                            type="checkbox"
                                                            id="sneakpeekSelect"
                                                            custom
                                                            checked={this.state.includeSneakPeekItems}
                                                            aria-label='Include Sneak Peek Items'
                                                            onChange={this.toggleSneakPeekItems}
                                                        />
                                                        <div className="select-all-text clickable" onClick={this.toggleSneakPeekItems}>Include Sneak Peek Items</div>
                                                    </div> : ''} */}
                                                    <div className={`d-flex align-items-center select-all-div ${this.state.includeClosedItems ? 'selected' : 'disabled'}`} >
                                                        <Form.Check
                                                            type="checkbox"
                                                            id="closedItemsSelect"
                                                            custom
                                                            checked={this.state.includeClosedItems}
                                                            aria-label='Include Closed Items'
                                                            onChange={this.toggleClosedItems}
                                                        />
                                                        <div className="select-all-text clickable" onClick={this.toggleClosedItems}>Include Closed Items</div>
                                                    </div>
                                                    {!this.state.noData &&
                                                        <>
                                                            <div className={`d-flex align-items-center select-all-div ${this.state.selectedAll ? 'selected' : 'disabled'}`} >
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id="customControlSelect"
                                                                    custom
                                                                    checked={this.state.selectedAll}
                                                                    aria-label='Select All'
                                                                    onChange={this.onChangeSelectAll}
                                                                />
                                                                <div className="select-all-text clickable" onClick={this.toggleSelectAll}>Select All</div>
                                                            </div>
                                                            <div>
                                                                <Button variant="secondary" size="sm" disabled={this.state.selectedItems.length === 0 || this.state.confirmLoader} onClick={this.removeFromWatch}>
                                                                    Remove {' '} {this.state.confirmLoader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                                                                </Button>
                                                            </div>
                                                        </>}
                                                </div>
                                            </div>
                                    }
                                    {/* <BiddingAndWatching page={"watching"}{...this.props} getItemsList={this.getItemsList} deleteItemsList={this.deleteItemsList}></BiddingAndWatching> */}
                                    {
                                        this.state.subloader || this.state.noRecordsFound ?
                                            null :
                                            <SaleCardViewDataTable className="px-12"
                                                config={{ postData: this.state.displayData.patchData }}{...this.props} showIcons extraDetailsUpdate={this.extraDetailsUpdate} 
                                                getItemsList={this.getItemsList} ref={this.saleCardView} showSelect={true} selectedItems={this.selectedItems}
                                                askConfirmForWatch watchingAndBiddingList={this.state.watchingList} condition="watching" sortBy={this.state.sortBy}
                                                stateMaintenance={this.stateMaintenance} selectedwatchingitems={this.state.selectedItems}
                                                dataloaded = {(itemlist) => {this.setState({moreButtonCheck: this.state.includeSneakPeekItems ? itemlist?.length >= 48 ? true : false : true})}}
                                            ></SaleCardViewDataTable>
                                    }
                                    {
                                        this.state.filterLoading && this.state.watchingList.length === 0 ?
                                            <div className={`d-flex justify-content-center h-100 ${this.state.noData || this.state.filterLoading ? 'align-items-center' : ''} mt-3`}>
                                                <div className="large-screen-width">
                                                    <div className="loader d-flex align-items-center justify-content-center h-100">
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                                    </div>
                                                </div>
                                            </div> : null
                                    }
                                    {
                                        this.state.watchingList.length == 0 ?
                                            <div className={`no-data-found h-75 d-flex flex-column justify-content-center align-items-center`}>
                                                {/* <div className="text-center no-data-search-icon">
                                                    <i className="fas fa-search fa-3x"></i>
                                                </div>
                                                <div className="text-center h4 text-bold">
                                                    No results found
                                                </div> */}
                                                <div className="text-center text-muted h5">
                                                    You don't have any items.
                                                </div>
                                            </div> : null
                                    }
                                </div>

                            </div>
                    }
                   {
                        (!this.state.pageLoading && this.state.nextList && this.state.watchingList.length  > 0 && this.state.moreButtonCheck) ? 
                            <div className="d-flex align-items-center browse-all-main justify-content-center">
                                <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                    More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                </div>
                            </div> : null
                    }

                </div>
            </div>
        );
    }
    // render() {
    //     return (
    //         <div className="watching-page">
    //             <div className="datatable h-100">
    //                 <div className={`d-flex justify-content-center h-100 ${this.state.noData ? 'align-items-center' : ''}`}>
    //                     <div className="large-screen-width">
    //                         <BiddingAndWatching page={"watching"}{...this.props} getItemsList={this.getItemsList} deleteItemsList={this.deleteItemsList}></BiddingAndWatching>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }
}

export default connect(state => state)(Watching);